module.exports = __webpack_public_path__ + "static/img/headerLogo.891262a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/headerLogo.png
// module id = 5Cpp
// module chunks = 2